export var KEY = {
    ARROW_DOWN: 'ArrowDown',
    ARROW_UP: 'ArrowUp',
    ENTER: 'Enter',
    ESCAPE: 'Escape',
    SPACE: 'Space',
};



//////////////////
// WEBPACK FOOTER
// ./src/components/MultiSelect/lib/constants.tsx
// module id = 167
// module chunks = 0